export default "__VITE_ASSET__BKV33O9v__"